export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M4.456 4.51c-.266-.061-.52.18-.441.44l4.118 13.567c.17.558.868.715 1.207.241l2.597-3.631 4.274 4.274c.741.74 1.954.74 2.694 0a1.91 1.91 0 000-2.694l-4.274-4.274 3.631-2.597c.475-.339.318-1.037-.241-1.207L4.455 4.51z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "#333",
    "viewBox": "0 0 24 24"
  }
};